<mat-toolbar class="toolbar-single">
  <div class="header-group">
    <button
      mat-icon-button
      class="menu-toggle"
      (click)="toggleSidenav()"
      *ngIf="isMobile"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <div class="page">
      <button
        *ngIf="header?.locationBack"
        class="mr-2"
        mat-icon-button
        (click)="goBack()"
      >
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="page-info">
        <h1>{{ header?.title || "Dashboard" }}</h1>
      </div>
    </div>

    <div class="user-actions-container">
      <app-messages></app-messages>
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <div class="user-initials">
          {{ avatar }}
        </div>
      </button>
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item disabled class="text-truncate user-name-item">
        Olá, {{ userName }}
      </button>

      <button mat-menu-item [routerLink]="['/configuracao']">
        <mat-icon>settings</mat-icon>
        <span>Configuração</span>
      </button>

      <button mat-menu-item (click)="changePassword()">
        <mat-icon>password</mat-icon>
        <span>Alterar minha senha</span>
      </button>

      <button mat-menu-item (click)="goToServiceDesk()">
        <mat-icon>help_center</mat-icon>
        <span>Preciso de ajuda</span>
      </button>

      <button mat-menu-item (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Sair</span>
      </button>
    </mat-menu>
  </div>
</mat-toolbar>
